import gql from "graphql-tag";

export const TUPLA_CSV_OBJETIVO_BATCH = gql`
  mutation agregarTuplaCsvObjBatch ($tuplaObjetivo: [tuplaObjetivo]) {
    agregarTuplaCsvObjBatch(tuplaObjetivo: $tuplaObjetivo)
  }
`

export const CSV_LOG = gql`
  fragment CsvLog on CsvLog {
    codigoDistribuidor
    nombreObjetivo
    fecha
    estado
  }
`;

export const CSV_LOGS_PAGE = gql`
  query csvLogsPage(
    $page: Int = 0,
    $size: Int = 50,
    $sortBy: String = "fecha",
    $sortDir: SortDir = asc
  ) {
    csvLogsPage(page: $page, size: $size, sortBy: $sortBy, sortDir: $sortDir) {
      content {
        ...CsvLog
      }
      pagination {
        totalPages
        totalElements
        numberOfElements
      }
    }
  }
  ${CSV_LOG}
`;

export const AJUSTE_MINIMO_DRAFT = gql`
  query AjusteMinimoDraft($codigoDistribuidor: Long, $codigoObjetivo: Int, $ano: Int) {
    ajusteMinimoDraft(
      codigoDistribuidor: $codigoDistribuidor
      codigoObjetivo: $codigoObjetivo
      ano: $ano
    ) {
      codigoDistribuidor
      codigoObjetivo
      ano
      mes
      valorMinimo
    }
  }
`;

export const INICIAR_PROCESADO_OBJETIVOS = gql`
  mutation IniciarProcesadoObjetivos {
    iniciarProcesadoObjetivos
  }
`
